import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_transfer_receiving_list = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("username");
  const branch = localStorage.getItem("branch");

  const canView  = hasPermission("Vehicle Receiving", "view");
      const canEntry = hasPermission("Vehicle Receiving", "entry");
    

  useEffect(() => {
    setLoading(true);
    axios.get(`https://rfs2.infraconsoft.net.in/api/vehicle_appr_to_receiving_list?branch=${branch}`)
      .then((response) => {
        setData(response.data.ReceivingList);
        setFilteredData(response.data.ReceivingList);
      })
      .catch((error) => {
        console.error("Error fetching ReceivingList:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [branch]);

  

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate pagination indexes
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_vehiclecode && item.fld_vehiclecode.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_transfer_from && item.fld_transfer_from.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_transfer_to && item.fld_transfer_to.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };

  // Get userId from localStorage


  const handleShiftUpdate = async (vehicleCode) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to receive this vehicle?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Receive it!",
      cancelButtonText: "No, Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
           Swal.fire({
                                      title: "Submitting...",
                                      text: "Please wait while we process your request.",
                                      allowOutsideClick: false,
                                      didOpen: () => {
                                        Swal.showLoading();
                                      },
                                    });
          const response = await axios.post("https://rfs2.infraconsoft.net.in/api/receive_vehicle", {
            vehicleCode,
            user: userId,
          });
  
          if (response.data.success) {
            Swal.fire("Received!", "Vehicle received successfully.", "success");
  
            setData((prevData) =>
              prevData.filter((item) => item.fld_vehiclecode !== vehicleCode)
            );
            window.location.reload();
          } else {
            Swal.fire("Error", response.data.message, "error");
          }
        } catch (error) {
          console.error("Error receiving vehicle:", error);
          Swal.fire("Error", "Something went wrong.", "error");
        }
      }
    });
  };
    

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Transferring - Receiving</h2>
          <div>
            <Time />
          </div>
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by vehicle Code"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
              <th>Vehicle Code</th>
                <th>Transfer From</th>
                <th>Transfer To</th> 
                <th>Transfer By</th>
                <th>Approved by  </th>
                {canEntry && (
                <th>Receive</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.fld_vehiclecode}</td>
                    <td>{item.fld_transfer_from}</td>
                    <td>{item.fld_transfer_to}</td>
                    <td>{item.fld_transfer_by}</td>
                    <td>{item.fld_approval_by}</td>
                    {canEntry && (
                    <td>
  <button onClick={() => handleShiftUpdate(item.fld_vehiclecode)} className="shift-btn">
    Receive
  </button>
</td>
                    )}

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? "active" : ""}>
              {index + 1}
            </button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_transfer_receiving_list;
